import { Component, Input, OnInit } from '@angular/core';

import { LuminousInvoicesChannelConstant } from '@app/core/_constant/channel.constants';
import { DefaultPageSizeOptionsConstant } from '@app/core/_constant/index.constants';
import { SalesService } from '@app/core/sales/services/sales.service';

@Component({
  selector: 'cnc-sku-stock-details-channel-orders',
  templateUrl: './sku-stock-details-channel-orders.component.html',
  styleUrls: ['./sku-stock-details-channel-orders.component.scss'],
})
export class SkuStockDetailsChannelOrdersComponent implements OnInit {
  constructor(private salesOrderSvc :SalesService) {}

  @Input() filters :any;
  params :any;
  records :any = { data: [] };
  pageSizeOptions :number[] = DefaultPageSizeOptionsConstant;
  loading :boolean;
  luminousInvoicesChannelLabel :string = LuminousInvoicesChannelConstant;

  ngOnInit() :void {
    this.filters.subscribe((params :any) => {
      this.params = params;
      this.getRecords();
    });
  }

  private setDefaultParams() :void {
    this.params.page = 1;
    this.params.per_page = 20;
    this.params.order = 'orderDate';
    this.params.sort = 'desc';
  }

  getRecords(params ?:any) :void {
    if (!params) {
      this.setDefaultParams();

      return this.getRecordsFromParams(this.params);
    }
    const {
      event,
      page,
      paramsOnly,
      exportType,
      length,
      pageIndex,
      pageSize,
      previousPageIndex,
    } = params;
    if (params.pageIndex || params.pageIndex == 0) {
      this.params.page = params.pageIndex + 1;
    }
    if (params.pageSize) {
      this.params.perPage = params.pageSize;
    }
    if (params.pageSize) {
      this.params.per_page = params.pageSize;
    }
    this.getRecordsFromParams(this.params);
  }

  private getRecordsFromParams(params :any) {
    this.loading = true;
    this.salesOrderSvc
      .getPendingTransactions(this.params)
      .subscribe((resp :any) => {
        this.records = resp;
        this.loading = false;
      });
  }
}
